import React from 'react'

const WhatNeoBusinessCard = () => {
  return (
    <>
    <div className='what_neo_business_Wrapper'>
    <div className='what_neo_business_content'>
    <h6>What is a Neoo Search digital business card?</h6>
        <h5>The Neoo search digital business card. Consider an electronic business card as your traditional card,
         but enhanced. It's adaptable, dynamic, and simple to distribute—eliminating the inconvenience (and waste) 
         of paper. Neoo Search Digital card creator, a simple method to exchange your details and expand your business
         connections</h5>

         <h5>The Single QR Code to Access All Your Links</h5>
    </div>


    </div>
      
    </>
  )
}

export default WhatNeoBusinessCard